import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "relative text-6xl flex w-full justify-center bg-center bg-[linear-gradient(to_bottom,transparent,transparent,black),url('@/assets/images/EquipmentRulesImage2Croppped.jpg')] h-96 bg-cover text-center text-white items-end pb-10" }, " Equipment Search ", -1)
const _hoisted_2 = { class: "max-w-screen-2xl px-4 sm:px-6 md:px-8 py-6 lg:mx-auto md:mx-8" }
const _hoisted_3 = { class: "grid grid-cols-4 gap-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("option", {
  value: "balls",
  selected: ""
}, " Balls ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: "drivers" }, " Driver Heads ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "fairway woods" }, " Fairway Woods ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: "hybrids" }, " Hybrids ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", { value: "irons" }, " Irons ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", { value: "wedges" }, " Wedges ", -1)
const _hoisted_10 = ["value"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("input", {
  type: "submit",
  class: "sr-only"
}, null, -1)
const _hoisted_12 = { class: "flex flex-col-reverse sm:flex-row sm:items-center sm:justify-between mt-4" }
const _hoisted_13 = { class: "flex items-center justify-start sm:justify-end gap-1" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg" }, " Sort By: ", -1)
const _hoisted_15 = {
  key: 0,
  id: "content",
  class: "symbol grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 2xl:grid-cols-7 gap-4 mt-4"
}
const _hoisted_16 = ["onClick", "onKeyup"]
const _hoisted_17 = {
  key: 1,
  class: "grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 2xl:grid-cols-7 gap-4 mt-4"
}
const _hoisted_18 = {
  key: 2,
  class: "flex justify-center mt-4"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl" }, " No Results Found ", -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "fixed bottom-4 w-full flex justify-center sm:justify-end px-4 z-50" }

import axios from 'axios'

	import SearchResult from './components/SearchResult.vue'
	import TwDrawer from '@/components/Drawers/TwDrawer.vue'
	import BallResultDetail from './components/BallResultDetails.vue'
	import ClubResultDetail from './components/ClubResultDetails.vue'
	import DriverResultDetail from './components/DriverResultDetails.vue'

	import { // icons
		ChevronDownIcon,
		MagnifyingGlassIcon,
		ArrowUpCircleIcon
	} from '@heroicons/vue/16/solid'

	import {
		InformationCircleIcon
	} from '@heroicons/vue/24/solid'

	import { // vue
		ref ,
		computed,
		onMounted
	} from 'vue'

	// store
	import { 
		store as _valueListStore
	} from '@/store/valueLists'

	// types
	import {
		Result,
		ValueListValue
	} from '@/types'

	//Events
	import EventBus from '@/events'
	
	import {
		useDebounceFn
	} from "@vueuse/core"

	
	const __default__ = { name: "EquipmentSearchMain" } 	// name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	const valueListStore = _valueListStore()
	const keyword = ref('')
	const equipmentType = ref('balls')
	const manufacturer = ref('')
	const sortField = ref('Manufacturer (A-Z)')

	const manufacturerListWhole = ref<ValueListValue[]>(valueListStore.valueList.manufacturers)
	const manufacturerListReduced = computed(()=> filterManufacturerList())

	const searchResults = ref<Result[]>([])
	const searchLoading = ref(false)
	const initialSearchComplete = ref(false)
	const searchPage = ref(1)
	const showReturnToTop = ref(false)
	const disableInfiniteScroll = ref(false)
	const pageSize = ref(0)

	async function search(add : Boolean) {
		if (!add) {
			searchResults.value.length = 0	
			showReturnToTop.value = false
			disableInfiniteScroll.value = false
		}

		if(equipmentType.value === 'balls' && sortField.value === 'Loft' ||
			equipmentType.value !== 'drivers' && sortField.value === 'Most Recent'
		) {
			sortField.value = 'Manufacturer (A-Z)'
		}
		searchLoading.value = true
		try{
			searchPage.value = add ? searchPage.value + 1 : 1
			const params = {
				manufacturer: manufacturer.value,
				equipmentType: equipmentType.value,
				keyword: keyword.value,
				sortField: sortField.value,
				searchPage : searchPage.value
			}
			const res = await axios.post(`search`, params)
			if(add){
				let currentLength = searchResults.value.length
				searchResults.value = searchResults.value.concat(res.data)
				if (currentLength + pageSize.value != searchResults.value.length){
					disableInfiniteScroll.value = true
				}
			}
			else{
				searchResults.value = res.data
			}
		}
		catch(e){
			console.log(e)
		}
		finally{
			searchLoading.value = false
			initialSearchComplete.value = true
		}
	}

	async function sort(method : string){
		sortField.value = method
		await search(false)
	}

	function filterManufacturerList(){
		let currentManufacturerList : ValueListValue[]
		if(manufacturer.value){
			currentManufacturerList = manufacturerListWhole.value.filter((item : ValueListValue)=>
			{return item.fullName?.toLowerCase()?.includes(manufacturer.value?.toLowerCase())}
			)
		}
		else{
			currentManufacturerList =  manufacturerListWhole.value
		}
		return currentManufacturerList.length < 50 ? currentManufacturerList : currentManufacturerList.slice(0,50)
	}

	function exitField(){
		document?.querySelector<HTMLInputElement>("input[name='manufacturer']")?.blur()
	}

	const resultDrawer = ref<{open: boolean}>({open: false})
	const selectedResult = ref<Result>({} as Result)

	function openResultDrawer(result: Result) {
		selectedResult.value = result
		resultDrawer.value.open = true
	}

	function returnToTop(){
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		})
	}

	onMounted(async()=> {
		searchLoading.value = true
		EventBus.on('infinite-scroll', async () => {
			if (initialSearchComplete.value && !(disableInfiniteScroll.value) && !(searchLoading.value)) {
				await search(true)
			}
			EventBus.trigger('infinite-scroll-end', null)
		})
		EventBus.on('scroll-up', () => {
			if(searchPage.value > 1 && !showReturnToTop.value){
				showReturnToTop.value = true
			}
		})

		await search(false)
		pageSize.value = searchResults.value.length
	})

	const searchOnStroke = useDebounceFn(async () => {
		return await search(false)
	}, 500)

return (_ctx: any,_cache: any) => {
  const _component_v_label = _resolveComponent("v-label")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_field = _resolveComponent("v-field")!
  const _component_v_input = _resolveComponent("v-input")!
  const _component_v_input_group = _resolveComponent("v-input-group")!
  const _component_v_datalist = _resolveComponent("v-datalist")!
  const _component_v_fieldset = _resolveComponent("v-fieldset")!
  const _component_v_dropdown_button = _resolveComponent("v-dropdown-button")!
  const _component_v_dropdown_item = _resolveComponent("v-dropdown-item")!
  const _component_v_dropdown_menu = _resolveComponent("v-dropdown-menu")!
  const _component_v_dropdown = _resolveComponent("v-dropdown")!
  const _component_v_text_link = _resolveComponent("v-text-link")!
  const _component_v_button = _resolveComponent("v-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (search(false)), ["prevent"]))
      }, [
        _createVNode(_component_v_fieldset, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_v_field, { class: "col-span-4 md:col-span-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Equipment Type")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_select, {
                    modelValue: equipmentType.value,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => ((equipmentType).value = $event)),
                      _cache[1] || (_cache[1] = ($event: any) => (search(false)))
                    ],
                    name: "equipment-type"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4,
                      _hoisted_5,
                      _hoisted_6,
                      _hoisted_7,
                      _hoisted_8,
                      _hoisted_9
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_field, { class: "col-span-4 md:col-span-2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Search by Keyword")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_input_group, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(MagnifyingGlassIcon)),
                      _createVNode(_component_v_input, {
                        modelValue: keyword.value,
                        "onUpdate:modelValue": [
                          _cache[2] || (_cache[2] = ($event: any) => ((keyword).value = $event)),
                          _unref(searchOnStroke)
                        ],
                        name: "search",
                        placeholder: "Search by keyword...",
                        "aria-label": "Search by keyword"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_field, { class: "col-span-4 md:col-span-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Equipment Manufacturer")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_input_group, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(MagnifyingGlassIcon)),
                      _createVNode(_component_v_input, {
                        modelValue: manufacturer.value,
                        "onUpdate:modelValue": [
                          _cache[3] || (_cache[3] = ($event: any) => ((manufacturer).value = $event)),
                          _unref(searchOnStroke)
                        ],
                        name: "manufacturer",
                        placeholder: "Type to search...",
                        "aria-label": "Type to search",
                        list: ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      (manufacturer.value && _unref(manufacturerListReduced).length)
                        ? (_openBlock(), _createBlock(_component_v_datalist, { key: 0 }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(manufacturerListReduced), (item, index) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: index,
                                  value: item.displayName,
                                  onClick: exitField
                                }, null, 8, _hoisted_10))
                              }), 128))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _hoisted_11
      ], 32),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(_component_v_dropdown, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_dropdown_button, {
                plain: "",
                size: "lg"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(sortField.value) + " ", 1),
                  _createVNode(_unref(ChevronDownIcon))
                ]),
                _: 1
              }),
              _createVNode(_component_v_dropdown_menu, {
                id: "sort-order",
                anchor: "bottom start"
              }, {
                default: _withCtx(() => [
                  (equipmentType.value === 'drivers')
                    ? (_openBlock(), _createBlock(_component_v_dropdown_item, {
                        key: 0,
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (sort('Most Recent')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Most Recent ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_dropdown_item, {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (sort('Manufacturer (A-Z)')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Manufacturer (A-Z) ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_dropdown_item, {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (sort('Manufacturer (Z-A)')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Manufacturer (Z-A) ")
                    ]),
                    _: 1
                  }),
                  (equipmentType.value !== 'balls')
                    ? (_openBlock(), _createBlock(_component_v_dropdown_item, {
                        key: 1,
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (sort('Loft')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Loft ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_v_text_link, {
          href: "https://www.usga.org/content/usga/home-page/equipment-standards/conforming-club-ball-lists.html",
          class: "mx-auto sm:mx-0 text-sm",
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Learn more about the Club and Ball Lists ")
          ]),
          _: 1
        })
      ]),
      (initialSearchComplete.value && searchResults.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchResults.value, (result, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                onClick: ($event: any) => (openResultDrawer(result)),
                onKeyup: _withKeys(($event: any) => (openResultDrawer(result)), ["enter"])
              }, [
                _createVNode(SearchResult, {
                  result: result,
                  "equipment-type": equipmentType.value
                }, null, 8, ["result", "equipment-type"])
              ], 40, _hoisted_16))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (searchLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(14, (index) => {
              return _createVNode(SearchResult, {
                key: index,
                result: {},
                loading: searchLoading.value
              }, null, 8, ["loading"])
            }), 64))
          ]))
        : _createCommentVNode("", true),
      (initialSearchComplete.value && !(searchResults.value.length) && !(searchLoading.value))
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
        : _createCommentVNode("", true)
    ]),
    _createVNode(TwDrawer, {
      ref_key: "resultDrawer",
      ref: resultDrawer,
      title: selectedResult.value.Manufacturer
    }, {
      default: _withCtx(() => [
        (equipmentType.value === 'balls')
          ? (_openBlock(), _createBlock(BallResultDetail, {
              key: 0,
              result: selectedResult.value
            }, null, 8, ["result"]))
          : (equipmentType.value === 'drivers')
            ? (_openBlock(), _createBlock(DriverResultDetail, {
                key: 1,
                result: selectedResult.value
              }, null, 8, ["result"]))
            : (_openBlock(), _createBlock(ClubResultDetail, {
                key: 2,
                result: selectedResult.value
              }, null, 8, ["result"]))
      ]),
      _: 1
    }, 8, ["title"]),
    _withDirectives(_createElementVNode("div", _hoisted_21, [
      _createVNode(_component_v_button, {
        class: "w-40 shadow-2xl",
        color: "red",
        size: "xl",
        onClick: returnToTop
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Back To Top "),
          _createVNode(_unref(ArrowUpCircleIcon))
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, showReturnToTop.value]
    ])
  ], 64))
}
}

})